import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { RoadCarrier } from "../../../types/models/RoadCarrier";
import ShipmentListItem from "../../../../timber/components/shipment/ShipmentList/ShipmentListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: RoadCarrier;
};

const RoadCarrierTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'shipment');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="RoadCarrier-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                    <Tab label={t`Shipments`} value="shipment"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                <TabPanel value={tabValue} index="shipment" data-testid="Shipment-tab">
                    <ShipmentListItem roadCarrierId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default RoadCarrierTabs;
